module.exports = __webpack_public_path__ + "static/media/avatar-4.e0ab315a.jpg";